import _ from 'lodash'
import PropTypes from 'prop-types'
import React, { useMemo, useState } from "react"
import { Accordion, Header, Icon } from "semantic-ui-react"
import { useTextResources } from '../../language'
import { ReservationAddons } from './ReservationAddons'
import './style.css'

export const ReservationAddonAccordion = ({
    initiallyExpended,
    ReservationDailyAddons,
    ...rest }) => {

    const text = useTextResources();

    const [expanded, setExpanded] = useState(initiallyExpended)

    const toggleExpended = (_event, data) => {
        setExpanded(!data.active)
    }

    const addonsShortDescription = useMemo(() => {

        if(!ReservationDailyAddons) {
            return []
        }

        return _(ReservationDailyAddons)
            .filter((rda) => rda.HotelAddon)
            .uniqBy((rda) => rda.HotelAddon?.ChainAddonId)
            .map((rda) => rda.HotelAddon?.ChainAddon?.Name)
            .compact()
            .join(", ")
    }, [ReservationDailyAddons])

    const addonsPanel = [{
        key: `addonsPanel`,
        title: {
            content: (
                <div className='addons-accordion-title-container'>
                    <div className='addons-accordion-title'>
                        <span>{text('Addons')}</span>
                        {rest.setShowExtraAddonsPopup && <Icon
                            name='pencil'
                            style={{ float: 'right' }}
                            link
                            onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                rest.setShowExtraAddonsPopup(true)
                            }}
                        />}
                    </div>
                    {
                        !expanded && (
                            <Header className='addons-short-description' size='tiny' title={addonsShortDescription}>
                                <Header.Content>
                                    {addonsShortDescription}
                                </Header.Content>
                            </Header>
                        )
                    }
                </div>
            ),
        },
        content: {
            content: (
                <ReservationAddons
                    ReservationDailyAddons={ReservationDailyAddons}
                />
            ),
        },
    }];


    return (
        <Accordion className='addons-accordion' defaultActiveIndex={initiallyExpended ? 0 : undefined} onTitleClick={toggleExpended} panels={addonsPanel} />
    )
}

ReservationAddonAccordion.propTypes = {
    ReservationDailyAddons: PropTypes.array.isRequired,
    setShowExtraAddonsPopup: PropTypes.func,
    initiallyExpended: PropTypes.bool,
}